import React, { useCallback } from 'react';
import { throttle } from 'js/utils/throttle.util';
import { useResizeObserver } from 'js/hooks/useResizeObserver';

export const useUpdateTableHeight = (
    tableItemsLength: number,
    tableItemRef: React.RefObject<HTMLDivElement>,
    tableHeight: React.Dispatch<React.SetStateAction<number>>
) => {
    const updateTableHeight = useCallback((): void => {
        const tableItem = tableItemRef.current;

        if (!tableItem) {
            return;
        }

        const { height } = tableItem.getBoundingClientRect();

        // where "1" is a 1px border-bottom of an item
        tableHeight(tableItemsLength * (height + 1));
    }, [tableItemsLength, tableHeight, tableItemRef]);

    return useResizeObserver({
        // eslint-disable-next-line react-hooks/exhaustive-deps
        callback: useCallback(throttle(updateTableHeight, 500), [updateTableHeight])
    });
};
